import { getCurrentPhase } from "../../utils";
import type { CampaignUser } from "../../../types/campaign";
import { navigateToPath } from "../../routing";
import PATHS from "../../constants/routePaths";

type SuccessPageData = {
  hasEstimatedDelivery: boolean;
  isUrlPromoCode: boolean;
  promoCode: string;
  showTrackYourGiftButton: boolean;
};

export const navigateToAlreadyOrderedPhaseWhenOnAlreadyOrderedPhase = (
  campaignUser: CampaignUser | undefined
) => {
  if (campaignUser) {
    const currentPhase = getCurrentPhase(campaignUser.metadata);
    if (currentPhase === "duplicate-order") {
      navigateToPath(PATHS.ALREADY_ORDERED);
    } else {
      console.log("Nothing to do here ...");
    }
  }
};

export const getSuccessPageCopyKey = (campaignUser: CampaignUser | undefined): string => {
  if (campaignUser) {
    const deliveryApi = campaignUser?.metadata.delivery_api;
    const currentPhase = getCurrentPhase(campaignUser?.metadata || {});
    if (currentPhase === "lucky-dip-phase") {
      return "success";
    }

    switch (deliveryApi) {
      case "digital":
        return "digitalSuccess";
      case "shipstation":
        return "postalSuccess";
      case "manual":
        return "manualSuccess";
      case "doordash_drive":
        return "success";
      default:
        return "success";
    }  
  } else {
    return "success";
  }
};

export const getSuccessPageData = (
  campaignUser: CampaignUser | undefined
): SuccessPageData | undefined => {

  const deliveryApi = campaignUser?.metadata.delivery_api;

  if (deliveryApi === "digital") {
    const promoCode = (campaignUser?.metadata?.digital_code as string) ?? "";
    return {
      hasEstimatedDelivery: false,
      isUrlPromoCode: /^http(s|):\/\//.test(promoCode),
      promoCode,
      showTrackYourGiftButton: false
    };
  } else if (deliveryApi === "doordash_drive") {
    return {
      hasEstimatedDelivery: true,
      isUrlPromoCode: false,
      promoCode: "",
      showTrackYourGiftButton: true
    };
  } else if (deliveryApi === "shipstation") {
    return {
      hasEstimatedDelivery: true,
      isUrlPromoCode: false,
      promoCode: "",
      showTrackYourGiftButton: false
    };
  } else {
    return {
      hasEstimatedDelivery: false,
      isUrlPromoCode: false,
      promoCode: "",
      showTrackYourGiftButton: false
    };
  }
};
